import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import { Typography, Chip } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CloseIcon from "@material-ui/icons/Close";
import {
  setFilterHokuden,
  setReportFilterHokuden,
  getSavedSelectedTagDataByEmail,
  getHomeImageDataHokuden,
  setCurrentPageNumber,
  getReportDataHokuden,
} from "../../actions";
import { getIsDeaAdmin } from "../../utils/deaRole";

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      width: 500,
      height: "100vh",
      padding: 16,
      boxSizing: "border-box",
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    filter: {
      marginLeft: theme.spacing(2),
      paddingTop: theme.spacing(3),
    },
    filterItem: {
      marginTop: theme.spacing(4),
    },
    filterButtonContainer: {
      position: "absolute",
      bottom: 45,
      left: "50%",
      transform: "translateX(-50%)",
      width: "100%",
      display: "flex",
      justifyContent: "space-around",
    },
    formControl: {
      margin: theme.spacing(1),
      width: "89%",
    },
    dataBtn: {
      minWidth: 200,
      height: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
    },
    tagSelect: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
      fontSize: 16,
      minWidth: 416,
      maxWidth: 416,
      "& .MuiInputLabel-root": {
        fontSize: "16px", // Smaller font size for the label (placeholder)
      },
      "& .MuiInputBase-input": {
        fontSize: "16px", // Customize input text size (if needed)
      },
    },
    scrollArea: {
      flexGrow: 1,
      overflowY: "auto",
      paddingRight: 8,
      paddingBottom: 16,
      marginBottom: 80,
    },
    header: {
      display: "flex",
      alignItems: "center",
      padding: "8px 0",
    },
    closeButton: {
      position: "absolute",
      top: 10,
      left: 8,
      zIndex: 10,
    },
    titleText: {
      fontSize: "1rem",
      fontWeight: "bold",
      marginLeft: 42,
    },
  })
);

const FilterDrawerHokuden = ({
  currentPage,
  periodType,
  toggleDrawer,
  anchor,
  setFilterHokuden,
  setReportFilterHokuden,
  filterStoreHokuden,
  reportFilterStoreHokuden,
  getSavedSelectedTagDataByEmail,
  getHomeImageDataHokuden,
  setCurrentPageNumber,
  filterType,
  reportTagFilterDataHokuden,
  getReportDataHokuden,
  cityOptions,
  branchOptions,
  hokudenOptionCity,
  hokudenOptionBranch,
}) => {
  const classes = useStyles();
  const isDeaAdmin = getIsDeaAdmin();
  const [sort, setSort] = useState(
    `${filterStoreHokuden.type}-${filterStoreHokuden.order}`
  );
  const [assetId, setAssetId] = useState("");
  const [tagData, setTagData] = useState([]);
  const [assetType, setAssetType] = useState("");
  const sortPrefix = filterType === "photo" ? "撮影" : "報告";
  const tagLabel = filterType === "photo" ? "結果タグ" : "報告タグ";

  useEffect(() => {
    let copyFilter =
      filterType === "photo"
        ? { ...filterStoreHokuden }
        : { ...reportFilterStoreHokuden };
    copyFilter.filterType = filterType;
    if (filterType === "photo") {
      setFilterHokuden(copyFilter);
    } else if (filterType === "report") {
      setReportFilterHokuden(copyFilter);
    }
  }, [currentPage]);

  useEffect(() => {
    setAssetId(
      filterType === "photo"
        ? filterStoreHokuden.assetId
        : reportFilterStoreHokuden.assetId
    );
  }, [filterStoreHokuden.assetId, reportFilterStoreHokuden.assetId]);

  useEffect(() => {
    setAssetType(
      filterType === "photo"
        ? filterStoreHokuden.assetType
        : reportFilterStoreHokuden.assetType
    );
  }, [filterStoreHokuden.assetType, reportFilterStoreHokuden.assetType]);

  useEffect(() => {
    if (reportTagFilterDataHokuden.length > 0) {
      const tagData = reportTagFilterDataHokuden.map((tag) => ({
        value: tag.value,
        label: tag.label,
        tip: tag.tip,
        count: tag.count,
      }));
      setTagData(tagData);
    }
  }, [reportTagFilterDataHokuden]);

  const handlePowerAssetNumberChange = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo"
        ? { ...filterStoreHokuden }
        : { ...reportFilterStoreHokuden };
    copyFilter.powerAssetNumber = value;
    if (filterType === "photo") {
      setFilterHokuden(copyFilter);
    } else if (filterType === "report") {
      setReportFilterHokuden(copyFilter);
    }
  };

  const handleUsernameChange = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo"
        ? { ...filterStoreHokuden }
        : { ...reportFilterStoreHokuden };
    copyFilter.username = value;
    if (filterType === "photo") {
      setFilterHokuden(copyFilter);
    } else if (filterType === "report") {
      setReportFilterHokuden(copyFilter);
    }
  };

  const handleAreaNameChange = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo"
        ? { ...filterStoreHokuden }
        : { ...reportFilterStoreHokuden };
    copyFilter.areaName = value;
    if (filterType === "photo") {
      setFilterHokuden(copyFilter);
    } else if (filterType === "report") {
      setReportFilterHokuden(copyFilter);
    }
  };

  // 市区町村
  const handleMunicipalityChange = (option) => {
    const value = option?.value || "all";
    const copyFilter = {
      ...(filterType === "photo" ? filterStoreHokuden : reportFilterStoreHokuden),
      municipality: value,
    };

    if (filterType === "photo") {
      setFilterHokuden(copyFilter);
    } else {
      setReportFilterHokuden(copyFilter);
    }
  };

  const handleBranchNameChange = (option) => {
    const value = option?.value || "all";
    let copyFilter =
      filterType === "photo"
        ? { ...filterStoreHokuden }
        : { ...reportFilterStoreHokuden };
    copyFilter.branchName = value;
    if (filterType === "photo") {
      setFilterHokuden(copyFilter);
    } else if (filterType === "report") {
      setReportFilterHokuden(copyFilter);
    }
  };

  const handleReviewStatusChange = (event) => {
    setFilterHokuden({
      ...filterStoreHokuden,
      reviewStatus: event.target.value,
    });
  };

  const handleSortChange = (event) => {
    const filterValue = event.target.value.split("-");
    const filter = {
      type: filterValue[0],
      order: filterValue[1],
      tag:
        filterType === "photo"
          ? filterStoreHokuden.tag
          : reportFilterStoreHokuden.tag,
      filterType: filterType,
      assetId:
        filterType === "photo"
          ? filterStoreHokuden.assetId
          : reportFilterStoreHokuden.assetId,
      assetType:
        filterType === "photo"
          ? filterStoreHokuden.assetType
          : reportFilterStoreHokuden.assetType,
      ...(filterType === "photo"
        ? { reviewStatus: filterStoreHokuden.reviewStatus }
        : {}),
    };
    setSort(event.target.value);
    if (filterType === "photo") {
      setFilterHokuden(filter);
    } else if (filterType === "report") {
      setReportFilterHokuden(filter);
    }
  };

  const fetchData = () => {
    if (
      filterStoreHokuden.tag !== undefined &&
      filterStoreHokuden.tag.length > 0
    ) {
      getSavedSelectedTagDataByEmail();
    } else {
      if (currentPage.includes("report")) {
        getReportDataHokuden({
          pageNumber: 1,
        });
      } else {
        getHomeImageDataHokuden({
          pageNumber: 1,
        });
      }
    }
    setCurrentPageNumber(1);
    toggleDrawer(anchor, false)();
  };

  const handleReset = () => {
    if (filterType === "photo") {
      setFilterHokuden({
        type: "occurred_datetime",
        order: "desc",
        tag: [],
        filterType: "photo",
        assetId: null,
        municipality: "all",
        branchName: "all",
        resultTag: "all",
        reviewStatus: "APPROVED",
        assetType: "all",
      });
    } else if (filterType === "report") {
      setReportFilterHokuden({
        type: "occurred_datetime",
        order: "desc",
        tag: [],
        tagResult: [],
        filterType: "report",
        assetId: null,
        municipality: "all",
        branchName: "all",
        resultTag: "all",
        assetType: "all",
      });
    }
    setAssetId("");
    setSort("occurred_datetime-desc");
    setAssetType("");
    toggleDrawer(anchor, false)();
    setCurrentPageNumber(1);
    if (filterType === "photo") {
      getHomeImageDataHokuden({
        pageNumber: 1,
      });
    } else {
      getReportDataHokuden({
        pageNumber: 1,
      });
    }
  };

  const handleSelectTagChange = (tags) => {
    let copyFilter =
      filterType === "photo"
        ? { ...filterStoreHokuden }
        : { ...reportFilterStoreHokuden };
    copyFilter.tag = tags;
    if (filterType === "photo") {
      setFilterHokuden(copyFilter);
    } else if (filterType === "report") {
      setReportFilterHokuden(copyFilter);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <IconButton
          className={classes.closeButton}
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer(anchor, false)}
          disableRipple={true}
          disableFocusRipple={true}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" className={classes.titleText}>
          絞り込み条件設定
        </Typography>
      </div>
      <div className={classes.scrollArea}>
        <Grid
          container
          direction="column"
          justifyContent={"flex-start"}
          className={classes.filter}
        >
          <Grid item className={classes.filterItem}>
            <TextField
              id="powerAssetNumber"
              label="電柱番号"
              variant="outlined"
              style={{ width: "89%", paddingLeft: 6 }}
              value={
                filterType === "photo"
                  ? filterStoreHokuden.powerAssetNumber !== "all"
                    ? filterStoreHokuden.powerAssetNumber
                    : ""
                  : reportFilterStoreHokuden.powerAssetNumber !== "all"
                  ? reportFilterStoreHokuden.powerAssetNumber
                  : ""
              }
              onChange={handlePowerAssetNumberChange}
            />
          </Grid>
          {/* <Grid item className={classes.filterItem}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="filter-assetType-label">エリア名</InputLabel>
              <Select
                labelId="simple-select-assetType-label"
                id="simple-select-assetType"
                value={filterStoreHokuden.photoType}
                onChange={handleAreaNameChange}
                label="エリア名"
              >
                <MenuItem value="all">全て</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
          <Grid item className={classes.filterItem}>
            <FormControl variant="outlined" className={classes.formControl}>
              <Autocomplete
                options={filterType === "photo" ? cityOptions : hokudenOptionCity}
                getOptionLabel={(option) => option.label}
                value={
                  filterType === "photo"
                    ? cityOptions.find((option) => option.value === filterStoreHokuden.municipality) ||
                      cityOptions[0]
                    : hokudenOptionCity.find((option) => option.value === filterStoreHokuden.municipality) ||
                      hokudenOptionCity[0]
                }
                onChange={(e, newValue) => {
                  if (newValue) {
                    handleMunicipalityChange(newValue)
                  }
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField {...params} label="市区町村" variant="outlined" />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item className={classes.filterItem}>
            <FormControl variant="outlined" className={classes.formControl}>
              <Autocomplete
                options={filterType === "photo" ? branchOptions : hokudenOptionBranch}
                getOptionLabel={(option) => option.label}
                value={
                  filterType === "photo"
                    ? branchOptions.find((option) => option.value === filterStoreHokuden.branchName) ||
                      branchOptions[0]
                    : hokudenOptionBranch.find((option) => option.value === filterStoreHokuden.branchName) ||
                      hokudenOptionBranch[0]
                }
                onChange={(e, newValue) => {
                  if (newValue) {
                    handleBranchNameChange(newValue);
                  }
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField {...params} label="支社コード" variant="outlined" />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item className={classes.filterItem}>
            <TextField
              id="username"
              label="撮影者"
              variant="outlined"
              style={{ width: "89%", paddingLeft: 6 }}
              value={
                filterType === "photo"
                  ? filterStoreHokuden.username !== "all"
                    ? filterStoreHokuden.username
                    : ""
                  : reportFilterStoreHokuden.username !== "all"
                  ? reportFilterStoreHokuden.username
                  : ""
              }
              onChange={handleUsernameChange}
            />
          </Grid>
          {filterType === "photo" && (
            <Grid item className={classes.filterItem}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="filter-review-status-label">レビュー結果</InputLabel>
                <Select
                  labelId="filter-review-status-label"
                  id="filter-review-status"
                  value={filterStoreHokuden.reviewStatus}
                  onChange={handleReviewStatusChange}
                  label="レビュー結果"
                >
                  <MenuItem value="APPROVED">OK</MenuItem>
                  <MenuItem value="REJECTED">NG</MenuItem>
                {isDeaAdmin && <MenuItem value="APPLY_WAITING">レビュー待ち</MenuItem>}
                </Select>
              </FormControl>
            </Grid>
          )}
          {filterType === "report" && (
            <Grid item className={classes.filterItem}>
              <Autocomplete
                multiple
                id="filter-tag-select"
                options={tagData}
                noOptionsText="データがありません"
                getOptionLabel={(option) => option.value || ""}
                getOptionSelected={(option, value) =>
                  option.value.toString() === value.toString()
                }
                value={
                  filterType === "photo"
                    ? filterStoreHokuden.tag !== undefined &&
                      filterStoreHokuden.tag.length > 0
                      ? tagData.filter((tag) =>
                          filterStoreHokuden.tag.includes(tag.value.toString())
                        )
                      : []
                    : reportFilterStoreHokuden.tag !== undefined &&
                      reportFilterStoreHokuden.tag.length > 0
                    ? tagData.filter((tag) =>
                        reportFilterStoreHokuden.tag.includes(
                          tag.value.toString()
                        )
                      )
                    : []
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    const selectedValues = newValue.map((tag) =>
                      tag.value.toString()
                    );
                    handleSelectTagChange(selectedValues);
                  } else {
                    handleSelectTagChange([]);
                  }
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      key={index}
                      size="small"
                      label={option.value}
                      {...getTagProps({ index })}
                      style={{ backgroundColor: "#f3ee91", color: "black" }}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={tagLabel}
                    className={classes.tagSelect}
                  />
                )}
                renderOption={(option) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body1">
                      <b>{option.label}</b> : {option.tip} ({option.count})
                    </Typography>
                  </div>
                )}
              />
            </Grid>
          )}
          <Grid item className={classes.filterItem}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="filter-sort-label">ソート</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={sort}
                onChange={handleSortChange}
                label="ソート"
              >
                <MenuItem value="occurred_datetime-desc">
                  {sortPrefix}日時 - 降順
                </MenuItem>
                <MenuItem value="occurred_datetime-asc">
                  {sortPrefix}日時 - 昇順
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <div className={classes.filterButtonContainer}>
            <Button
              className={classes.dataBtn}
              variant="contained"
              color="primary"
              onClick={fetchData}
            >
              絞り込む
            </Button>
            <Button
              className={classes.dataBtn}
              variant="contained"
              color="default"
              onClick={handleReset}
            >
              リセット
            </Button>
          </div>
        </Grid>
      </div>
    </div>
  );
};

FilterDrawerHokuden.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  currentPage: state.app.currentPage,
  periodType: state.app.periodType,
  filterStoreHokuden: state.home.filterHokuden,
  reportFilterStoreHokuden: state.report.filterHokuden,
  reportTagFilterDataHokuden: state.report.reportTagFilterDataHokuden,
  cityOptions: state.home.hokudenOptionCity,
  branchOptions: state.home.hokudenOptionBranch,
  hokudenOptionCity: state.report.hokudenOptionCity,
  hokudenOptionBranch: state.report.hokudenOptionBranch,
});

const mapDispatchToProps = (dispatch) => ({
  setFilterHokuden: (param) => dispatch(setFilterHokuden(param)),
  setReportFilterHokuden: (param) => dispatch(setReportFilterHokuden(param)),
  getSavedSelectedTagDataByEmail: () => dispatch(getSavedSelectedTagDataByEmail()),
  getHomeImageDataHokuden: (param) => dispatch(getHomeImageDataHokuden(param)),
  setCurrentPageNumber: (param) => dispatch(setCurrentPageNumber(param)),
  getReportDataHokuden: (param) => dispatch(getReportDataHokuden(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(FilterDrawerHokuden));
